import { createContext, ReactNode, useContext } from 'react'
import { SchedulingStatus, useSchedulingState } from '../../../../hooks'

interface Props {
  children: ReactNode
}

interface UseIsFormReadyContext {
  isReady: boolean
}

const defaultContext: UseIsFormReadyContext = {
  isReady: false,
}

const context = createContext(defaultContext)
const { Provider } = context

const IsFormReadyProvider = ({ children }: Props) => {
  const { status } = useSchedulingState()

  const isReady = status === SchedulingStatus.IDLE

  return <Provider value={{ isReady }}>{children}</Provider>
}

const useIsFormReady = () => useContext(context)

export { IsFormReadyProvider, useIsFormReady }
